export const credits = {
  mobile: [
    'Tom McCaffrey',
    'Attila Farkas',
    'Jackie Harnish',
    'Edwin Rivera',
    'Aneesa Shaik',
    'Jason Merchan',
    'Ethan Wang',
    'Hitanshu Oza',
  ],
  web: [
    'Edwin Rivera',
    'Muhammad Rashid Mahfooz',
    'Ryan Janelli',
    'Attila Farkas',
    'Sumeet Singh',
    'Yash Nishikant',
    'Tanay Desai',
    'Samarth Verma',
  ],
  backend: [
    'Amy Jordan',
    'Timothy Lui',
    'Paul Bernard',
    'Tom McCaffrey',
    'Edwin Rivera',
  ],
  systemArchitect: ['Yaw-Shing Wang'],
  pastContributors: [
    'John Cinquegrana',
    'Nicholas Summers',
    'Nico Spadavecchia',
    'Kevin Shah',
    'Ushio (Louis) Shinohara',
    'Matthew Enad',
    'Daniel Trotter',
    'Allen Davis-Swing',
    'Sidhu Arakkal',
    'Aadit Singh',
    'Rasika Nanasaheb Punde',
    'Shreesh Keskar',
    'Ruben Alias',
  ],
}
